import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "1-trend-09-top1",
  "use": "1-trend-09-top1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"1-trend-09-top1\"><path d=\"M65.582671 735.208665l446.417329-446.41733 446.417329 446.41733z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol